
export const LOCALES = ['en', 'no', 'sv', 'pl', 'zh-cn', 'zz']
